import { render } from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { CssBaseline } from '@material-ui/core';

import { App } from '@/components/App';
import { Layout } from '@/components/Layout';
import { UserProvider } from '@/components/UserContext';

export const queryClient = new QueryClient();

render(
  <>
    <CssBaseline />
    <QueryClientProvider client={queryClient}>
      <UserProvider>
        <Layout>
          <App />
        </Layout>
      </UserProvider>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  </>,
  document.getElementById('root')
);
